<template>
  <common-dialog ref="dialog" width="600px" show-save-button title="快递更新" @edit-opened="onEditOpened" :data="data"
    :save-func="getDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="快递单号" prop="快递单号">
        <el-input v-model="data.快递单号" placeholder="请输入快递单号，以逗号隔开"></el-input>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      // api: require('@/api/ent/dp').default,
      data: {
        快递单号: "",
      },
    };
  },
  methods: {
    onEditOpened(data) {
      console.log("data", data);
      // this.data.ids = { ...data }
    },
    getDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
      })
    },
  },
};
</script>
